import { render, staticRenderFns } from "./SerpToolbarTitle.vue?vue&type=template&id=3bd09492&scoped=true"
import script from "./SerpToolbarTitle.vue?vue&type=script&lang=js"
export * from "./SerpToolbarTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd09492",
  null
  
)

export default component.exports